import { createContext, ReactNode, useState } from "react";
import { safeLocalStorage } from "../utils/safeLocalStroage.ts";

// Define the types for the context value
interface CookieContextType {
  cookie: boolean;
  changeCookie: (theme: boolean) => void;
}

function initCookie() {
  const localCookie = safeLocalStorage.getItem("cookie");
  if (localCookie) return !!JSON.parse(localCookie);
  return false;
}

// Create the context with default values
export const CookieContext = createContext<CookieContextType>({
  cookie: initCookie(),
  changeCookie: () => {
    console.warn("changeCookie before init");
  },
});

interface ThemeProviderProps {
  children: ReactNode;
}

export const CookieProvider = ({ children }: ThemeProviderProps) => {
  const [cookie, setCookie] = useState<boolean>(initCookie());

  const changeCookie = (state: boolean) => {
    setCookie(state);
    safeLocalStorage.setItem("cookie", JSON.stringify(state));
  };

  return (
    <CookieContext.Provider
      value={{
        cookie: cookie,
        changeCookie: changeCookie,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};
